import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {CloseIcon} from '../../icon/svg/close-icon';
import {LoadingPage} from '../../loading-page/loading-page';
import {ModalLightbox} from '../../modal/modal-lightbox';

import styles from './video-modal-native.module.css';

export type VideoProgress = {
    currentTimeSecs: number;
    durationSecs: number;
    percentComplete: number;
};

type Props = {
    onClose: (progress: VideoProgress | null) => void;
    videoUrl: string;
    title: string;
};

export function VideoModalNative(props: Props) {
    const {onClose} = props;
    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const videoRef = React.useRef<HTMLVideoElement>(null);

    const handleClose = React.useCallback(() => {
        const video = videoRef.current;

        if (video && video.duration && !isNaN(video.duration)) {
            onClose({
                currentTimeSecs: Math.round(video.currentTime),
                durationSecs: Math.round(video.duration),
                percentComplete: Math.round((video.currentTime / video.duration) * 100),
            });
        } else {
            onClose(null);
        }
    }, [onClose, videoRef]);

    return (
        <ModalLightbox onClose={handleClose} canClickOutsideToClose={true}>
            <div
                className={styles['modal-container']}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                <div className={styles['modal-chrome']}>
                    <div className={styles['header-row']}>
                        <div className={styles.title}>{props.title}</div>
                        <button
                            type='button'
                            className={styles['close-button']}
                            aria-label='Close video'
                            onClick={handleClose}
                        >
                            <CloseIcon size={16} wrapWithDiv={false} />
                        </button>
                    </div>
                    <div className={styles['video-frame']}>
                        {isLoading && (
                            <div className={styles['loading-state']}>
                                <LoadingPage size={56} fullHeight={false} />
                            </div>
                        )}
                        <video
                            ref={videoRef}
                            className={styles.video}
                            controls={true}
                            autoPlay={true}
                            playsInline={true}
                            preload='auto'
                            onCanPlay={() => {
                                setIsLoading(false);
                            }}
                        >
                            <source src={props.videoUrl} />
                        </video>
                    </div>
                </div>
            </div>
        </ModalLightbox>
    );
}
